import { AImageProps } from '../../atoms/AImage/AImage.types';
import { MMediaBorderProps } from '../MMediaBorder/MMediaBorder.types';

export enum MMediaStackImageDirection {
  Diagonal = 'Diagonal',
  Centered = 'Centered',
}

export enum MMediaStackAspectRatio {
  TwoThree = '2:3',
  OneOne = '1:1',
  /** Figma composite: large primary 1:1 + smaller secondary 2:3 (uses Centered layout). */
  OneOnePlusTwoThree = '1:1 + 2:3',
}

export enum MMediaStackImageLayout {
  Default = 'Default',
  Reverse = 'Reverse',
}

export interface MMediaStackProps extends React.HTMLAttributes<HTMLDivElement> {
  imageDirection?: MMediaStackImageDirection;
  aspectRatio?: MMediaStackAspectRatio;
  imageLayout?: MMediaStackImageLayout;
  aImage: AImageProps;
  mMediaBorder?: MMediaBorderProps;
}
